//showing the products and option to increase ot decrease the amount
//
//form for the user to add his detailsand cradit card to do it in deferent component?

//on click submit: showing to the user a massage, sending to the admin order details as one order maby to study about some Api that sending mail to the user and the admin.
import React, { useContext, useEffect, useState } from "react";
import { storeContext } from "../../context/context";
import "./ProductCard.css";
import "./CartOrder.css";
import MainSearchBar from "./Search/MainSearchBar";
import { useNavigate } from "react-router-dom";
// import { ROUTES_LINKS } from '../../routes/routes'
import { useStore } from "../../context/store.provider";
import emailjs from "emailjs-com";
import { ROUTES_LINKS } from "../../routes/routes";
import { createOrder } from "./GettingData/firebase";
import { priceFormatter } from "../admin/algoritem";
import Footer from "./Footer";

function CartOrderForm() {
  const Navigate = useNavigate();
  const { setChoosenProducts, choosenProducts } = useStore();
  const { totalPrice, setTotalPrice, setNumProducts } =
    useContext(storeContext);
  const [client, setClient] = useState({
    firstName: "",
    lastName: "",
    number: "",
    Email: "",
  });

  const handleClickAdd = (index, price) => {
    const newArrProducts = [...choosenProducts];
    newArrProducts[index].productAmount =
      newArrProducts[index].productAmount + 1;
    setChoosenProducts(newArrProducts);
    setTotalPrice((prev) => prev + price);
  };

  const handleClickDelete = (index, price, productAmount) => {
    const newProducts = [...choosenProducts];
    console.log(newProducts);
    newProducts.splice(index, 1);
    setChoosenProducts(newProducts);
    setTotalPrice((prev) => prev - price * productAmount);
    setNumProducts((prev) => prev - 1);
  };
  const handleClickMinus = (index, price) => {
    if (choosenProducts[index].productAmount > 1) {
      const newArrProducts = [...choosenProducts];
      newArrProducts[index].productAmount =
        newArrProducts[index].productAmount - 1;
      setChoosenProducts(newArrProducts);
      setTotalPrice((prev) => prev - price);
    }
  };
  const handleNavigation = () => {
    Navigate(ROUTES_LINKS.TO_STORE);
  };
  const onChangeName = ({ target: { value } }) => {
    setClient((prev) => ({ ...prev, firstName: value }));
  };
  const onChangeLastName = ({ target: { value } }) => {
    setClient((prev) => ({ ...prev, lastName: value }));
  };
  const onChangeNumber = ({ target: { value } }) => {
    setClient((prev) => ({ ...prev, number: value }));
  };
  const onChangeMail = ({ target: { value } }) => {
    setClient((prev) => ({ ...prev, Email: value }));
  };
  const handleClickOrder = async (e) => {
    // here to do minimum total price of order else alert or some popUp you need to order more
    e.preventDefault();
    const minOrder = totalPrice > 5;
    const order = {
      firstName: client.firstName,
      lastName: client.lastName,
      number: client.number,
      Email: client.Email,
      completed:false,
      products: choosenProducts,
      totalOrderPrice: totalPrice,
    };
    if (minOrder) {
      createOrder(order);
      sendEmail(e);
      setChoosenProducts([]);
      setTotalPrice(0);
      setNumProducts(0);
    } else {
      alert("you order amount under minimum order");
    }

    // next need to do active order and completed order
    //!!! the last thing its to show massage to the user your order comlete succesful and you got mail with details, go to a new order
  };
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wowl35g",
        "template_akzwcdi",
        e.target,
        "8YimBpcQB1ncS328P"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  }

  return (
    <div className="cart-order-form-page">
      <div className="navbar">
        <div className="logo">
          <img src={require(`../../assets/images/logo.png`)} alt="logo" />
        </div>
        {/* the function search not working because there is no data in this components */}
        <MainSearchBar />
        <button onClick={handleNavigation}>
          <i className="fa-solid fa-backward"></i>
          <i className="fa-solid fa-store"></i> המשך קנייה
        </button>
      </div>
      <div className="cart-order-form-con" >
        <div className="products-in-cart">
          {choosenProducts.map(
            (
              { id, category, imgUrl, price, productName, productAmount },
              index
            ) => (
              <>
                <div className="container" key={id}>
                  <div key={id} className="card">
                    <div className="imgBx">
                      <img src={imgUrl} alt={productName} />
                      <div className="contentBx">
                        <h2 className="text-card">{productName}</h2>
                        <div className="size">
                          <h3 className="text-card">{category}</h3>
                        </div>
                        <div className="color">
                          <h3 className="text-card">
                            {priceFormatter.format(price)}
                          </h3>
                        </div>
                        <div className="cart-product-buttons" >
                          <button
                            className="plus-minus-btn"
                            onClick={() => handleClickAdd(index, price)}
                          >
                            +
                          </button>
                          <button
                            className="plus-minus-btn"
                            onClick={() => handleClickMinus(index, price)}
                          >
                            -
                          </button>
                          <button
                            className="remove-btn"
                            onClick={() =>
                              handleClickDelete(index, price, productAmount)
                            }
                          >
                            <i
                              style={{ color: "black" }}
                              className="fa-solid fa-trash"
                            ></i>
                          </button>
                        </div>
                        <div className="text-card" id="numProduct">
                          {productAmount}
                        </div>
                        {/* to bring from awsome font icons of plus minus and Delete */}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
          )}
        </div>
        <div className="total-price">
          {" "}
          סכום הזמנה {priceFormatter.format(totalPrice)}
        </div>
        <div className="form-container">
          {/* <div className="payment">
          <h3>Payment</h3>
          <label htmlFor="fname">Accepted Cards</label>
          <div className="icon-container">
            <i className="fa-brands fa-cc-visa visa" ></i>
            <i className="fa-brands fa-cc-mastercard mastercard"></i>
            <i className="fa-brands fa-cc-amex amex"></i>
          </div>
          <label htmlFor="cname">Name on Card</label>
          <input type="text" id="cname" name="cardname" placeholder="John More Doe" />
          <label htmlFor="ccnum">Credit card number</label>
          <input type="text" id="ccnum" name="cardnumber" placeholder="1111-2222-3333-4444" />
          <label htmlFor="expmonth">Exp Month</label>
          <input type="text" id="expmonth" name="expmonth" placeholder="September" />

          <div className="row">
            <div className="col-50">
              <label htmlFor="expyear">Exp Year</label>
              <input type="text" id="expyear" name="expyear" placeholder="2026" />
            </div>
            <div className="col-50">
              <label htmlFor="cvv">CVV</label>
              <input type="text" id="cvv" name="cvv" placeholder="352" />
            </div>
          </div>
        </div> */}
          <form className="order-form" onSubmit={handleClickOrder}>
            <div className="client-details">
              <label htmlFor="firstName">
                <i className="fa-solid fa-user"></i> שם פרטי
              </label>
              <input
                onChange={onChangeName}
                type="text"
                name="firstName"
                value={client.firstName}
                required
              />
              <label htmlFor="firstName">
                <i className="fa-solid fa-users"></i>שם משפחה
              </label>
              <input
                onChange={onChangeLastName}
                type="text"
                name="lastName"
                value={client.lastName}
                required
              />
              <label htmlFor="number">
                <i className="fa-solid fa-phone"></i>מספר טלפון
              </label>
              <input
                onChange={onChangeNumber}
                name="number"
                value={client.number}
                type="phone"
                required
              />
              <label htmlFor="Mail">
                <i className="fa-solid fa-envelope"></i> מייל
              </label>
              <input
                onChange={onChangeMail}
                type="email"
                name="subject"
                value={client.Email}
                required
              />
              {/* <textarea
                resize="none"
                id="massage-to-client"
                name="massage"
                rows="4"
                cols="2"
                placeholder="הערות להזמנה"
              ></textarea> */}
              {/* here need to add text area that sending to my grandfathe comments of clients */}
            </div>
            <div className="btn-order">
              <button type="submit">השלם הזמנה</button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CartOrderForm;
